import { render, staticRenderFns } from "./promoterEndOrder.vue?vue&type=template&id=47035b7e&scoped=true&"
import script from "./promoterEndOrder.vue?vue&type=script&lang=js&"
export * from "./promoterEndOrder.vue?vue&type=script&lang=js&"
import style0 from "./promoterEndOrder.vue?vue&type=style&index=0&id=47035b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47035b7e",
  null
  
)

export default component.exports